<template>
  <div class="ad-popup">
    <div v-if="showPopup">
      <div class="ad-mask" @click="hidePopup"></div>
      <div class="img-wrap">
        <img :src="bgimg" @click="toNewPage">
        <div class="close" @click="hidePopup">
          <i class="iconfont icon-cha"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getAd, getCoupon} from '@/api/ad-popup.js'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      showPopup: false,
      bgimg: '',
      url: '',
      coupon_ids: ''
    }
  },
  created() {
    this._getAd()
  },
  methods: {
    _getAd() {
      getAd().then(res => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          let d = data.data
          if (d.is_pop === 1) {
            this.showPopup = true
            this.bgimg = d.bgimg
            this.url = d.url
            this.coupon_ids = d.coupon_ids
          }
        }
      }, err => {
        console.log(err)
      })
    },
    _getCoupon() {
      getCoupon(this.coupon_ids).then(res => {
        let data = res.data
        if (data && data.code === RES_OK) {
          this.$toast(data.msg)
          this.showPopup = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    toNewPage() {
      if (this.coupon_ids) {
        this._getCoupon()
      } else {
        location.href = this.url
      }
    },
    hidePopup() {
      this.showPopup = false
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .ad-popup{
    .ad-mask{
      position fixed
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .3)
      z-index 9
    }
    .img-wrap{
      position fixed
      top: 50%;
      left: 50%;
      width: 80%;
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      z-index 10
      img{
        width: 100%;
      }
      .close{
        text-align center
        margin-top: size(40)
        .iconfont{
          color: #fff;
          font-size size(60)
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/base/ad-popup/index.vue